<template>
    <div class="autofactura-section">
        <div class="autofactura-content">
            <h2 class="autofactura-title fuente-posm">
                Los Clientes Ahora se Auto Facturan
            </h2>
            <p class="autofactura-text fuente-nova">
                Imprimimos desde el primer ticket un QR code inteligente. El cliente lo escanea, ingresa sus datos fiscales, y recibe su factura al instante. Sin captura manual de datos.
            </p>
        </div>
        <div class="autofactura-image">
            <img :src="a60" alt="Auto facturación">
        </div>
    </div>
</template>

<script>
export default {
    name: 'AutoFacturacionNew',
    data() {
        return {
            a60: require('@/assets/images/a60.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.autofactura-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.autofactura-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.autofactura-image img {
    width: 400px;
    height: auto;
}

.autofactura-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.autofactura-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.autofactura-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .autofactura-title {
        font-size: 60px;
    }

    .autofactura-text {
        font-size: 27px;
    }

    .autofactura-image img {
        width: 320px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .autofactura-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .autofactura-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .autofactura-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .autofactura-image img {
        width: 80%;
        max-width: 320px;
    }

    .autofactura-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .autofactura-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
